<p-button appPreventDoubleClick styleClass="p-button-outlined" icon="fas fa-chevron-circle-left" id="previousPhaseButton" tooltipPosition="left" pTooltip="Previous Phase" iconPos="left" (debounceClick)="documentPreviousPhase()"></p-button>
